AoPS.Feed = (function (Feed) {
	var Lang = AoPS.Community.Lang;

	Feed.preloaded_topic = null;

	Feed.preload_feed_tag_id = 0;

	Feed.preload_feed_tag_text = "";

	Feed.constructFeed = function () {
		var category_id, page_feed_title;
		//This should be in the master initialize, probably.
		if (!AoPS.Community.is_active) {
			return;
		} else {
			//console.log('community not active');
		}

		// Check if this function has been run.
		if (typeof this.community_master === "object") {
			return {
				community_master: this.community_master,
				feed_master: this.feed_master,
				feed_view: this.feed_view,
			};
		}

		if (!AoPS.Community.hasOwnProperty("MasterModel")) {
			AoPS.Community.MasterModel = new AoPS.Community.Models.Master({
				in_community: false,
			});
		}

		this.community_master = AoPS.Community.MasterModel;

		/* FEED MUST COME AFTER Backbone start!*/
		// experimenting with delay to let the page render before Feed is built.
		// If this seems to work well, we'll want to animate the feed in.
		this.feed_master = new AoPS.Community.Models.Feed({
			master: this.community_master,
		});
		this.feed_view = new AoPS.Feed.Views.FeedMaster({
			model: this.feed_master,
		});
		AoPS.Feed.Master = this.feed_master;

		if (AoPS.bootstrap_data.hasOwnProperty("preload_feed_focus_topic")) {
			AoPS.Feed.preloaded_topic =
				this.community_master.processPotentialNewTopic(
					AoPS.bootstrap_data.preload_feed_focus_topic
				);
		}
		if (AoPS.bootstrap_data.hasOwnProperty("preload_feed_tag_id")) {
			AoPS.Feed.preload_feed_tag_id = parseInt(
				AoPS.bootstrap_data.preload_feed_tag_id
			);
		}
		if (AoPS.bootstrap_data.hasOwnProperty("preload_feed_tag_text")) {
			AoPS.Feed.preload_feed_tag_text =
				AoPS.bootstrap_data.preload_feed_tag_text;
		}
		if (!_.isNull(AoPS.Feed.preloaded_topic)) {
			category_id = AoPS.Feed.preloaded_topic.get("category_id");

			/*if (AoPS.bootstrap_data.hasOwnProperty('page_feed_preload_topics')) {
				preloaded_topics = this.community_master.processPotentialNewTopics(AoPS.bootstrap_data.page_feed_preload_topics, false);
				filtered_list = this.community_master.fetchFilteredTopicList({
					category : this.community_master.fetchCategory(category_id),
					tag_ids : [{
						tag_id : AoPS.Feed.preload_feed_tag_id,
						tag_forum_id : category_id
					}],
					category_id : category_id
				});
				filtered_list.add(preloaded_topics);
				filtered_list.all_topics_fetched = AoPS.bootstrap_data.page_feed_all_topics_fetched;
			}*/
			/**
			 * If tag_id 0, add the topics with force
			 */
			this.feed_view.$el.addClass("feed-preloaded-topic");
		}
		$("body").append(this.feed_view.$el);
		if (!_.isNull(AoPS.Feed.preloaded_topic)) {
			if (typeof AoPS.bootstrap_data.page_feed_preload_title === "string") {
				page_feed_title = AoPS.bootstrap_data.page_feed_preload_title;
			} else {
				page_feed_title = "Linked Item Topics";
			}

			this.openPageFeed({
				category_id: category_id,
				tag_id: AoPS.Feed.preload_feed_tag_id,
				tag_text: AoPS.Feed.preload_feed_tag_text,
				subtitle: page_feed_title,
			});
			this.feed_master.set("focus_topic", AoPS.Feed.preloaded_topic);
		}

		return {
			community_master: this.community_master,
			feed_master: this.feed_master,
			feed_view: this.feed_view,
		};
	};

	Feed.setPageFeedSubtitle = function (title) {
		var $subtitle;
		if (!AoPS.Community.is_active) {
			return;
		}

		$subtitle = this.feed_view.page_subfeed.view.$el.find(".feed-subtitle");

		this.feed_master.get("page_subfeed_settings").subtitle = title;
		if (title.length === 0) {
			this.feed_view.page_subfeed.view.$el.find(".feed-subtitle").remove();
		} else if ($subtitle.length > 0) {
			$subtitle.html(title);
		} else {
			$subtitle = '<div class="feed-subtitle">' + title + "</div>";
			this.feed_view.page_subfeed.view.$el
				.find(".feed-subfeed-header")
				.after($subtitle);
		}
	};

	/**
	 * Set the page feed to a given category_id, tag_id combination.
	 *  The category_id must be submitted; the tag_id defaults to 0.
	 *
	 * Input either as an object with properties category_id, tag_id, subtitle
	 *  or {int}, {int, int}, {int, int, string}, {int, string, string}
	 *
	 * You can also replace tag_id with tag_text anywhere in these arguments.  So, {int, string} and {int, string, string}
	 *	are fine.
	 *
	 * The following are all fine:
	 *
	 * AoPS.Feed.setPageFeed(4, 48); //category_id 4, tag_id 48
	 * AoPS.Feed.setPageFeed(4, 48, 'HI MOM'); //category_id 4, tag_id 48, subtitle "HI MOM"
	 * AoPS.Feed.setPageFeed(4, 'geometry', 'HI MOM'); //category_id 4, tag 'geometry', subtitle "HI MOM"
	 * AoPS.Feed.setPageFeed(4, 'geometry'); //category_id 4, tag 'geometry'
	 * AoPS.Feed.setPageFeed(4); //category_id 4, no tag, no subtitle
	 * AoPS.Feed.setPageFeed({
	 *		category_id : 4,
	 *		tag_id : 48,
	 *	});
	 * AoPS.Feed.setPageFeed({
	 *		category_id : 4,
	 *		subtitle : 'HI MOM'
	 *	});
	 *
	 * @return boolean.  Are these settings new?
	 ***/
	Feed.setPageFeed = function (obj) {
		var current_settings,
			reset_settings = false;
		if (!AoPS.Community.is_active) {
			return;
		}

		current_settings = this.feed_master.get("page_subfeed_settings");
		this.feed_view.$el.removeClass("feed-hide-page-feed");

		if (typeof arguments[0] === "number") {
			if (obj === 0) {
				// No category, fail
				return;
			}
			obj = {
				category_id: arguments[0],
			};

			if (arguments.length === 1) {
				obj.tag_id = 0;
			} else {
				if (typeof arguments[1] === "number") {
					obj.tag_id = arguments[1];
				} else {
					obj.tag_text = arguments[1];
				}

				if (arguments.length === 3) {
					obj.subtitle = arguments[2];
				}
			}
		} else {
			obj = _.extend({tag_id: 0, subtitle: ""}, obj);
		}
		if (
			current_settings.hasOwnProperty("category_id") &&
			obj.hasOwnProperty("category_id")
		) {
			if (current_settings.category_id === obj.category_id) {
				if (obj.hasOwnProperty("tag_id") && obj.tag_id > 0) {
					// New setting tag_id, if no tag or difft tag on the old, reset
					if (
						!current_settings.hasOwnProperty("tag_id") ||
						parseInt(current_settings.tag_id) !== obj.tag_id
					) {
						reset_settings = true;
					}
				} else {
					// New setting tag_text, if no tag or difft tag on the old, reset
					if (obj.hasOwnProperty("tag_text") && obj.tag_text.length > 0) {
						if (
							!current_settings.hasOwnProperty("tag_text") ||
							current_settings.tag_text !== obj.tag_text
						) {
							reset_settings = true;
						}
					} else if (
						current_settings.hasOwnProperty("tag_id") &&
						parseInt(current_settings.tag_id) > 0
					) {
						reset_settings = true;
					}
				}
			} else {
				// change category, change page feed
				reset_settings = true;
			}
		} else {
			// Only happens if no current settings
			reset_settings = true;
		}
		if (reset_settings) {
			this.feed_master.set("page_subfeed_settings", obj);
		}
		return reset_settings;
	};

	/**
	 * Hide the page feed and remove the page feed button
	 **/
	Feed.hidePageFeed = function () {
		if (!AoPS.Community.is_active) {
			return;
		}
		this.feed_view.$el.addClass("feed-hide-page-feed");
		if (this.feed_view.page_subfeed === this.feed_view.active_subfeed) {
			this.feed_view.closeFeed();
		}
	};

	Feed.closePageFeed = function () {
		if (!AoPS.Community.is_active) {
			return;
		}
		if (this.feed_view.page_subfeed === this.feed_view.active_subfeed) {
			AoPS.Feed.feed_master.set("focus_topic", null);
			this.feed_view.closeFeed();
		}
	};

	/**
	 * Set the page feed to the given data, and then open the page feed.
	 **/
	Feed.openPageFeed = function (obj) {
		if (AoPS.bd.is_free_trial_enrollment) {
			AoPS.Ui.Modal.showMessage(Lang["cat-cell-no-perm-free-trial"]);
			return;
		}
		if (!AoPS.Community.is_active) {
			AoPS.Ui.Modal.showAlert(Lang["err-community-disabled"]);
			return;
		}

		if (typeof arguments[0] === "number") {
			if (obj === 0) {
				// No category, fail
				return;
			}
			obj = {
				category_id: arguments[0],
				subtitle: "",
			};
			if (arguments.length === 1) {
				obj.tag_id = 0;
			} else if (typeof arguments[1] === "number") {
				obj.tag_id = arguments[1];
			} else {
				obj.tag_id = 0;
				obj.tag_text = arguments[1];
			}
			if (arguments.length === 3) {
				obj.subtitle = arguments[2];
			}
		} else {
			obj = _.extend({tag_id: 0}, obj);
		}
		if (
			this.setPageFeed(obj) ||
			!AoPS.Feed.feed_view.isPageSubfeedOpen() ||
			(obj.hasOwnProperty("force_open") && obj.force_open)
		) {
			this.activatePageSubfeed();
		} else {
			this.closePageFeed();
		}
	};

	Feed.activatePageSubfeed = function () {
		this.feed_view.activatePageSubfeed();
		this.feed_view.showFeed();
	};

	Feed.activateGlobalSubfeed = function () {
		if (typeof this.feed_view.global_subfeed === "object") {
			this.feed_view.openFeed(this.feed_view.global_subfeed, 0);
		}
	};

	/**
	 * Launch a new topic from a page outside the community.
	 *
	 * @param object
	 *		category_id int required
	 *		tags : array of strings optional
	 *		linked_tag string optional,
	 * 		content string optional: pre-seed the new topic's text with content,
	 *		restricted_tags array of strings optional (these are tags that need permission checks)
	 *		target_url string optional,
	 *		filter_tag string optional tag to filter to after topic posted (default target_url),
	 *		onFinish : function to call after finishing (optional)
	 *		hidden_tags : array of strings optional (primary_url automatically included)
	 */
	Feed.startNewTopic = function (obj) {
		if (!AoPS.Community.is_active) {
			AoPS.Ui.Modal.showAlert(Lang["err-community-disabled"]);
			return;
		}
		if (obj.category_id === 0) {
			AoPS.Community.Views.showError(Lang["feed-no-forum"]);
			return;
		}

		var category = this.community_master.fetchCategory(obj.category_id),
			settings = _.extend(
				{
					tags: [],
					target_url: "",
					target_text: "",
					subtitle: "",
					content: "",
					linked_tag: "",
					filter_tag: "",
					hidden_tags: [],
					restricted_tags: [],
					onSuccess: function () {},
				},
				obj
			);

		if (AoPS.bd.is_free_trial_enrollment) {
			AoPS.Ui.Modal.showMessage(Lang["cat-cell-no-perm-free-trial"]);
		} else if (!AoPS.session.logged_in) {
			AoPS.Ui.buildLoginConfirm(Lang["new-topic-not-logged-in"]);
		} else if (!AoPS.session.initialized) {
			AoPS.Initialize.display({escapable: true});
		} else if (AoPS.isUserCoppaBlocked()) {
			AoPS.displayCoppaBlockedModal({escapable: true});
		} else if (
			!category.getPermission("c_undo_global_ban") &&
			!AoPS.hasFreeResourceAccess() &&
			!AoPS.in_academy
		) {
			const message = Lang["cat-cell-no-perm-free-resource"];
			AoPS.Ui.Modal.showMessage(message, {
				width: "450px",
			});
		} else if (_.isUndefined(category)) {
			// TODO : Throw a loading message, then go get the category
			AoPS.Ui.Modal.showMessage(Lang["new-topic-no-category"]);
		} else if (
			!category.getPermission("c_can_start_topic") &&
			!category.getPermission("c_undo_global_ban")
		) {
			AoPS.Ui.Modal.showMessage(Lang["cat-cell-no-perm-start-topic"]);
		} else {
			if (settings.linked_tag !== "") {
				settings.tags = _.without(settings.tags, settings.linked_tag);
				settings.tags.push(settings.linked_tag);
			}
			settings.special_item = settings.linked_tag;
			delete settings.linked_tag;
			settings.model = category;
			settings.filter_tag =
				settings.filter_tag.length > 0
					? settings.filter_tag
					: settings.target_url;
			settings.master = this.community_master;
			// eslint-disable-next-line no-new
			new AoPS.Feed.Views.NewTopic(settings);
		}
	};

	// t-open feed   V-new topic

	/**
	 * Build a button that fires a New Topic window.
	 *
	 * @param object
	 *		category_id int required -- id of the forum you're posting in
	 *		$button jQuery object optional -- thing you're clicking on to get the action
	 *		tags array of strings -- tags to pre-add
	 *		target_url string optional -- url to connect this conversation to (you'll be sad if you leave this out)
	 *		hidden_tags array of strings optional other urls you want to connect
	 */
	Feed.buildNewTopicButton = function (obj) {
		var $button = $(
			'<div class="new-topic-btn" title="Start topic about this">V</div>'
		);

		return this.activateNewTopicButton(
			_.extend(
				{
					$button: $button,
				},
				obj
			)
		);
	};

	Feed.activateNewTopicButton = function (obj) {
		obj.$button.on("click", function () {
			if (!AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
			} else if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
			} else if (!AoPS.hasFreeResourceAccess() && !AoPS.in_academy) {
				const message = Lang["cat-cell-no-perm-free-resource"];
				AoPS.Ui.Modal.showMessage(message, {
					width: "450px",
				});
			} else {
				AoPS.Feed.startNewTopic(obj);
			}
		});

		return obj.$button;
	};

	Feed.buildOpenFeedButton = function (obj) {
		var $button = $(
			'<div class="open-feed-btn" title="View discussions about this">t</div>'
		);

		return this.activateOpenFeedButton(
			_.extend(
				{
					$button: $button,
				},
				obj
			)
		);
	};

	Feed.activateOpenFeedButton = function (obj) {
		obj.$button.on("click", function () {
			AoPS.Feed.openPageFeed(obj);
		});

		return obj.$button;
	};

	/**
	 * When the user calls a route from a topic, it
	 *  places feed/<topic_id>/ at the start of the URL.
	 *  We place a regexp in the router to strip it off, and then call this
	 *  function with what's left in order to send the router to the right place.
	 **/
	Feed.onFeedRoute = function (url) {
		if (_.isNull(url)) {
			url = "";
		}
		if (url.substr(0, 1) === "/") {
			url = url.substr(1);
		}

		// The community hasn't been built yet.
		if (!AoPS.Community.hasOwnProperty("MasterModel")) {
			/*AoPS.Community.MasterModel = new AoPS.Community.Models.Master({
				in_community : false
			});*/
			Feed.constructFeed();
		}

		Backbone.history.navigate(url, {
			trigger: true,
			replace: true,
		});
		var focus_topic = AoPS.Community.MasterModel.get("focus_topic");
		if (!_.isNull(focus_topic)) {
			AoPS.Feed.activatePageSubfeed();
			AoPS.Feed.feed_master.set("focus_topic", focus_topic);
		}
		AoPS.Community.MasterModel.set("focus_topic", null);
	};

	Feed.openTopic = function (topic_id) {
		if (!AoPS.Community.is_active) {
			return;
		}

		var focus_topic = AoPS.Community.MasterModel.fetchTopicById(topic_id),
			self = this,
			feed_focus_topic = AoPS.Feed.feed_master.get("focus_topic");

		// See notes in feed_views.js about past_topic_id
		if (
			(!_.isNull(feed_focus_topic) &&
				topic_id === feed_focus_topic.get("topic_id")) ||
			AoPS.Feed.feed_view.past_topic_id === topic_id
		) {
			if (AoPS.Feed.feed_view.isPageSubfeedOpen()) {
				this.closePageFeed();
				return;
			}
		}

		if (!_.isNull(focus_topic) && !_.isUndefined(focus_topic)) {
			AoPS.Feed.activatePageSubfeed();
			AoPS.Feed.feed_master.set("focus_topic", focus_topic, {
				no_ajax_override: true,
			});
		} else {
			AoPS.Feed.activatePageSubfeed();
			this.feed_view.throwTopicBlocker();
			focus_topic = AoPS.Community.MasterModel.fetchTopicFromDb({
				topic_id: topic_id,
				onFinish: function (data) {
					AoPS.Feed.feed_master.set("focus_topic", data.topic, {
						no_ajax_override: true,
					});
				},
				onError: function (data) {
					self.onTopicError(data);
				},
			});
		}
	};

	Feed.onTopicError = function (data) {
		var msg;
		switch (data.error_code) {
			case "E_NO_SUCH_TOPIC":
				msg = Lang["feed-no-topic"];
				break;

			case "E_NO_PERMISSION":
				msg = Lang["feed-no-read-permission"];
				break;

			default:
				msg = AoPS.Community.Utils.formatString(Lang["err-unknown"], [
					data.error_code,
				]);
				break;
		}

		AoPS.Feed.feed_view.cleanTopicWindow();

		AoPS.Community.Views.showError(msg);
	};

	Feed.openTopicSetFeed = function (args) {
		if (!AoPS.Community.is_active) {
			return;
		}

		// If the feed is not visible (small screen width), instead go directly
		// to the target page in a new tab (preempting openPageFeed).
		if ($("body").width() <= 700) {
			var c = AoPS.bd.grid_data.class.forum_id;
			var h = arguments[0];
			window.open("/community/c" + c + "h" + h, "_blank");
			return;
		}

		var topic_id = arguments[0],
			is_new_page_feed,
			feed_opening = false,
			self = this,
			is_page_subfeed_open = AoPS.Feed.feed_view.isPageSubfeedOpen(),
			page_feed_args = Array.prototype.slice.apply(arguments).slice(1),
			topic = AoPS.Feed.feed_master.get("focus_topic");

		is_new_page_feed = this.setPageFeed.apply(this, page_feed_args);
		// See notes in feed_views.js about past_topic_id
		if (
			(!_.isNull(topic) && topic.get("topic_id") === topic_id) ||
			AoPS.Feed.feed_view.past_topic_id === topic_id
		) {
			if (is_page_subfeed_open && !is_new_page_feed) {
				this.closePageFeed();
				return;
			}
		}

		if (!AoPS.Feed.feed_view.feed_open) {
			this.openPageFeed.apply(this, page_feed_args);
			feed_opening = true;
		}

		this.activatePageSubfeed();
		if (feed_opening) {
			setTimeout(function () {
				self.openTopic(topic_id);
			}, AoPS.Feed.feed_view.animate_speed * 1.1);
		} else {
			this.openTopic(topic_id);
		}
	};

	return Feed;
})(AoPS.Feed || {});
